import { render } from "./Subscrtiptions.vue?vue&type=template&id=20b9cca0&scoped=true"
import script from "./Subscrtiptions.vue?vue&type=script&lang=js"
export * from "./Subscrtiptions.vue?vue&type=script&lang=js"

import "./Subscrtiptions.vue?vue&type=style&index=0&id=20b9cca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b9cca0"]])

export default __exports__